import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import useLanguageContext from '../../languages/context';
import Language from '../buttons/Language';
import Signin from '../buttons/Signin';
import Signup from '../buttons/Signup';
const Button = () => {
    const [language] = useLanguageContext();
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: "w-fit", children: _jsx(Language, { content: `Current language: ${language.name}` }) }), _jsxs("div", { className: "flex flex-row gap-2 justify-center", children: [_jsx(Signin, { content: language.navBar.signin }), _jsx(Signup, { content: language.navBar.signup })] })] }));
};
export default Button;
